import { types } from "mobx-state-tree";

import GenericJSONPrimitive from "./GenericJSONPrimitive";

const Aggregation = types.model({
  id: types.identifier,
  timestamp: types.optional(types.string, ""),
  payload: types.optional(GenericJSONPrimitive, "{}")
});

const AggregationStore = types.model({
  aggregations: types.map(Aggregation)
});

export { Aggregation, AggregationStore };
